import gql from 'graphql-tag';

export const PolicyPreviewResponse = gql`
  fragment PolicyPreviewResponse on PolicyPreview {
    id
    coverageChange
    itemsChanged
    itemsChangedAddendum
    billingDescription
    newPremium
    newTotalPrice
    clarionDoorIds {
      requestIdBeforePreview
      requestIdAfterPreview
    }
    feesChanged
    nextPayments {
      date
      remainingMonthly
    }
    diff
    skipImmediateBillOrRefund
    warning
    trailingDocChanges {
      timeStamp
      newValue
      oldValue
      addedChangeKey
      agent
      documentType
      newValueUM
      oldValueUM
      newValueUIM
      oldValueUIM
    }
    createdBy {
      username
      isAgency
    }
  }
`;

export const Address = gql`
  fragment Address on AddressDetails {
    address
    address2
    unit
    country
    city
    state
    zip
  }
`;

export const People = gql`
  fragment People on PersonDetails {
    id
    age
    isPrimary
    isCoApplicant
    firstName
    middleName
    lastName
    suffix
    gender
    excludeDriver
    maritalStatus
    takenCourse
    courseDiscountConditionCheck
    highestEducation
    dateOfBirth
    driversLicenseNumber
    driversLicenseState
    skipLicenseNumValidation
    ageFirstLicensed
    fullTimeStudent
    goodStudent
    exclusionReason
    removedReason
    removedBy
    removedTimestamp
    schoolName
    addDate
    communityDriveParticipation
    communityDriveScore
    everCommunityDriveParticipation
    needSR22
    lapsedLicense
    hasViolationsBlockingUmbrella
    insuranceScore {
      homeTotal
      autoTotal
      total
    }
    schoolLocation {
      ...Address
    }
    autoViolationDates
    waivedPIPWL
    pipEligible
    pipOptOut
    pipHasQHC
    assignedCar
    userAssignedCar
    autoViolations {
      AAF
      AFM
      ANC
      ANO
      ASW
      BOT
      CCW
      CML
      CMP
      CMPTV
      CMU
      CRD
      DEQ
      DEV
      DR
      DWI
      FAR
      FDL
      FEL
      FFR
      FLE
      FRA
      FTC
      FTY
      HOM
      IBK
      IP
      IT
      LDL
      LIC
      LTS
      MAJ
      MMV
      NAF
      NFX
      PUA
      PUN
      REF
      RKD
      SAF
      SCH
      SLV
      SPD
      SUS
      TMP
      UDR
      WSR
    }
  }
`;
